import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, Stack, Typography } from '@mui/material';
import { AUTH_KEYS, NS } from '../../i18n/constants/keys';
import { AnimatedChangePassword } from '../../assets/svgs/ChangePasswordAnimate';
import { RootState } from '../../utils/redux_store/store';
import { AuthenticationUiLayout } from './AuthenticationUILayout';
import { CompanyLogoBadge } from './CompanyLogoBadge';

export const TermsConditions: React.FC = () => {
  const history = useHistory();
  const { t } = useTranslation(NS.auth);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    history.push(`/identity-check/${localStorage.getItem('token')}`);
  };

  const companyLogo = useSelector((state: RootState) => state.logo.companyLogo);
  const companyName = useSelector((state: RootState) => state.logo.companyName);

  return (
    <AuthenticationUiLayout leftContent={<AnimatedChangePassword />}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', gap: 2.5 }}>
        <CompanyLogoBadge
          logoUrl={companyLogo}
          companyName={companyName}
          altText='HiAcuity Logo'
        />
        <Typography
          variant="h4"
          sx={{
            fontSize: { xs: '1.5rem', sm: '1.875rem' },
            fontWeight: 800,
            color: '#0f172a',
            letterSpacing: '-0.02em',
          }}
        >
          {t(AUTH_KEYS.terms.title)}
        </Typography>
      </Box>

      <Box
        component="form"
        onSubmit={handleSubmit}
        data-testid="change-password-form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2.5,
          mt: 3,
          width: '100%',
        }}
      >
        <Box
          sx={{
            bgcolor: '#f8fafc',
            border: '1px solid #e2e8f0',
            borderRadius: '16px',
            p: 2.5,
            maxHeight: 260,
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
          }}
        >
          <Typography variant="body2" sx={{ color: '#475569', lineHeight: 1.6 }}>
            {t(AUTH_KEYS.terms.para1)}
          </Typography>
          <Typography variant="body2" sx={{ color: '#475569', lineHeight: 1.6 }}>
            {t(AUTH_KEYS.terms.para2)}
          </Typography>
          <Typography variant="body2" sx={{ color: '#475569', lineHeight: 1.6 }}>
            {t(AUTH_KEYS.terms.para3)}
          </Typography>
        </Box>

        <Button
          fullWidth
          type="submit"
          variant="contained"
          sx={{
            mt: 1,
            py: 1.5,
            px: 3,
            borderRadius: '9999px',
            bgcolor: '#050508',
            color: '#ffffff',
            fontSize: '0.875rem',
            fontWeight: 600,
            textTransform: 'none',
            boxShadow: '0 4px 14px rgba(0, 0, 0, 0.16)',
            '&:hover': {
              bgcolor: '#1e293b',
              boxShadow: '0 6px 20px rgba(0, 0, 0, 0.22)',
            },
          }}
        >
          {t(AUTH_KEYS.terms.consentContinue)}
        </Button>
      </Box>
    </AuthenticationUiLayout>
  );
};
